// src/redux/reducers/wastageReportReducer.js
import {
  FETCH_WASTAGE_SUMMARY_REQUEST,
  FETCH_WASTAGE_SUMMARY_SUCCESS,
  FETCH_WASTAGE_SUMMARY_FAILURE,
  FETCH_WASTAGE_BY_PURCHASE_REQUEST,
  FETCH_WASTAGE_BY_PURCHASE_SUCCESS,
  FETCH_WASTAGE_BY_PURCHASE_FAILURE,
  FETCH_WASTAGE_BY_PRODUCT_REQUEST,
  FETCH_WASTAGE_BY_PRODUCT_SUCCESS,
  FETCH_WASTAGE_BY_PRODUCT_FAILURE,
  FETCH_DETAILED_WASTAGE_REQUEST,
  FETCH_DETAILED_WASTAGE_SUCCESS,
  FETCH_DETAILED_WASTAGE_FAILURE,
  FETCH_MANUAL_WASTAGE_REQUEST,
  FETCH_MANUAL_WASTAGE_SUCCESS,
  FETCH_MANUAL_WASTAGE_FAILURE
} from '../../Action/WastageReportAction/WastageReportAction';

const initialState = {
  summary: null,
  byPurchase: [],
  byProduct: [],
  manualWastage: {
    records: [],
    summary: {
      total_wastage_kg: 0,
      total_records: 0,
      total_products: 0,
      total_cost: 0
    },
    total: 0
  },
  detailed: {
    records: [],
    total: 0
  },
  loading: false,
  error: null
};

const WastageReportReducer = (state = initialState, action) => {
  switch (action.type) {
    // Summary
    case FETCH_WASTAGE_SUMMARY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_WASTAGE_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        summary: action.payload
      };
    case FETCH_WASTAGE_SUMMARY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // By Purchase Order
    case FETCH_WASTAGE_BY_PURCHASE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_WASTAGE_BY_PURCHASE_SUCCESS:
      return {
        ...state,
        loading: false,
        byPurchase: action.payload
      };
    case FETCH_WASTAGE_BY_PURCHASE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // By Product
    case FETCH_WASTAGE_BY_PRODUCT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_WASTAGE_BY_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        byProduct: action.payload
      };
    case FETCH_WASTAGE_BY_PRODUCT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Detailed Report
    case FETCH_DETAILED_WASTAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_DETAILED_WASTAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        detailed: action.payload
      };
    case FETCH_DETAILED_WASTAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Manual Wastage
    case FETCH_MANUAL_WASTAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_MANUAL_WASTAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        manualWastage: action.payload
      };
    case FETCH_MANUAL_WASTAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Add Wastage
    case 'ADD_WASTAGE_REQUEST':
      return {
        ...state,
        loading: true,
        error: null
      };
    case 'ADD_WASTAGE_SUCCESS':
      return {
        ...state,
        loading: false
      };
    case 'ADD_WASTAGE_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default WastageReportReducer;
